<app-search-menu
  [entries]="queryAllParticipants.bind(this)"
  (entrySelected)="selectParticipant($event)"
>
  <ng-content></ng-content>
</app-search-menu>
